export const getTrackingPageUrl = (trackingNumber: string): string =>
	`https://tracking${
		window.location.origin.includes('cc.easproject.com') ? '' : '-dev'
	}.easproject.com/?tracking=${trackingNumber}`;
